import {
	ADD_LESSON_ENTITY,
	ADD_SECTION_HEADING_ENTITY,
	ADD_FINAL_QUIZ_ENTITY,
	ADD_NODE_TO_PARENT,
	UPDATE_LESSONS,
	UPDATE_SECTION_HEADINGS,
	SET_ACTIVE_LESSON,
	ADD_TOPIC_ENTITY,
	SET_DRAGGABLE_ENTITY,
	SET_IS_DROP_DISABLED_LESSON,
	ADD_QUIZ_ENTITY,
	UPDATE_QUESTIONS,
	ADD_QUESTION_ENTITY,
	ADD_ANSWER_ENTITY,
	REMOVE_ANSWER_ENTITY,
	UPDATE_WORKSPACE_NODE_TITLE,
	TOGGLE_EXPAND_ALL,
	TOGGLE_EXPAND_ENTITY,
	SORT_FINAL_QUIZZES_OUTLINE,
	REMOVE_ENTITY,
	REMOVE_EXISTING_ENTITY,
	REMOVE_SECTION_HEADING_ENTITY,
	MOVE_ENTITY,
	UPDATE_QUESTION_TYPE,
	UPDATE_QUESTION_ANSWERS,
} from '~/constants';

/**
 * Update lessons
 *
 * @param {*} payload
 */
export const updateLessons = ( payload ) => {
	return {
		type: UPDATE_LESSONS,
		payload,
	};
};

/**
 * Adds a new lesson in the store. It'll be under workspace
 *
 * @param {*} payload
 */
export const addLessonEntity = ( payload ) => {
	return {
		type: ADD_LESSON_ENTITY,
		payload,
	};
};

/**
 * Adds a new section heading in the store. It'll be under workspace
 *
 * @param {*} payload
 */
export const addSectionHeadingEntity = ( payload ) => {
	return {
		type: ADD_SECTION_HEADING_ENTITY,
		payload,
	};
};

/**
 * Update section headings
 *
 * @param {*} payload
 */
export const updateSectionHeadings = ( payload ) => {
	return {
		type: UPDATE_SECTION_HEADINGS,
		payload,
	};
};

/**
 * Adds a node to a parent node
 *
 * @param {*} payload
 */
export const addNodeToParent = ( payload ) => {
	return {
		type: ADD_NODE_TO_PARENT,
		payload,
	};
};

/**
 * Sets the active lesson
 *
 * @param {*} payload
 */
export const setActiveLesson = ( payload ) => {
	return {
		type: SET_ACTIVE_LESSON,
		payload,
	};
};

/**
 * Adds a new topic under the active lesson.
 *
 * @param {*} parent
 * @param {number} destinationIndex
 * @param {*} payload
 */
export const addTopicEntity = ( parent, destinationIndex, payload ) => {
	return {
		type: ADD_TOPIC_ENTITY,
		parent,
		destinationIndex,
		payload,
	};
};

/**
 * Adds a new quiz under the active lesson.
 *
 * @param {*} parent
 * @param {number} destinationIndex
 * @param {*} payload
 */
export const addQuizEntity = ( parent, destinationIndex, payload ) => {
	return {
		type: ADD_QUIZ_ENTITY,
		parent,
		destinationIndex,
		payload,
	};
};

/**
 * Update questions
 *
 * @param {*} payload
 */
export const updateQuestions = ( payload ) => {
	return {
		type: UPDATE_QUESTIONS,
		payload,
	};
};

/**
 * Adds a new question in the store. It'll be under workspace
 *
 * @param {*} payload
 */
export const addQuestionEntity = ( payload ) => {
	return {
		type: ADD_QUESTION_ENTITY,
		payload,
	};
};

/**
 * Adds a new answer in the store. It'll be under workspace
 *
 * @param {*} payload
 * @param {*} parent
 */
export const addAnswerEntity = ( payload, parent ) => {
	return {
		type: ADD_ANSWER_ENTITY,
		payload,
		parent,
	};
};

/**
 * Removes an answer from the store.
 *
 * @param {*} payload
 * @param {*} parent
 */
export const removeAnswerEntity = ( payload, parent ) => {
	return {
		type: REMOVE_ANSWER_ENTITY,
		payload,
		parent,
	};
};

/**
 * Sets which entity is being dragged
 *
 * @param {*} payload
 */
export const setDraggableEntity = ( payload ) => {
	return {
		type: SET_DRAGGABLE_ENTITY,
		payload,
	};
};

/**
 * Sets the is drop disable property in our store
 *
 * @param {*} payload
 */
export const setIsDropDisabledLesson = ( payload ) => {
	return {
		type: SET_IS_DROP_DISABLED_LESSON,
		payload,
	};
};

/**
 * Updates the title for a node
 *
 * @param {*} payload
 */
export const updateWorkspaceNodeTitle = ( payload ) => {
	return {
		type: UPDATE_WORKSPACE_NODE_TITLE,
		payload,
	};
};

/**
 * Toggles the expand all variable
 *
 * @param {*} payload
 */
export const toggleExpandAll = ( payload ) => {
	return {
		type: TOGGLE_EXPAND_ALL,
		payload,
	};
};

/**
 * Toggles the expand entity
 *
 * @param {*} parent
 * @param {*} payload
 */
export const toggleExpandEntity = ( parent, payload ) => {
	return {
		type: TOGGLE_EXPAND_ENTITY,
		parent,
		payload,
	};
};

/**
 * Adds a final quiz
 *
 * @param {number} index
 * @param {*} payload
 */
export const addFinalQuizEntity = ( index, payload ) => {
	return {
		type: ADD_FINAL_QUIZ_ENTITY,
		index,
		payload,
	};
};

/**
 * Sorts the final quizzes
 *
 * @param {*} payload
 */
export const sortFinalQuizzesOutline = ( payload ) => {
	return {
		type: SORT_FINAL_QUIZZES_OUTLINE,
		payload,
	};
};

/**
 * Removes an entity from the workspace
 *
 * @param {*} payload
 */
export const removeEntity = ( payload ) => {
	return {
		type: REMOVE_ENTITY,
		payload,
	};
};

/**
 * Removes a section heading entity from the workspace
 *
 * @param {*} payload
 */
export const removeSectionHeadingEntity = ( payload ) => {
	return {
		type: REMOVE_SECTION_HEADING_ENTITY,
		payload,
	};
};

/**
 * Removes an existing entity from the workspace. Similar to removEntity but use this one for moving entities.
 * We can then exclude that action from redux undo since when moving entities, it'll count as 2 actions.
 *
 * @param {*} payload
 */
export const removeExistingEntity = ( payload ) => {
	return {
		type: REMOVE_EXISTING_ENTITY,
		payload,
	};
};

/**
 * Moves an entity up
 *
 * @param {*} payload
 */
export const moveUp = ( payload ) => {
	return {
		type: MOVE_ENTITY,
		direction: 'up',
		payload,
	};
};

/**
 * Moves an entity down
 *
 * @param {*} payload
 */
export const moveDown = ( payload ) => {
	return {
		type: MOVE_ENTITY,
		direction: 'down',
		payload,
	};
};

/**
 * Updates a question type
 *
 * @param {*} payload
 */
export const updateQuestionType = ( payload ) => {
	return {
		type: UPDATE_QUESTION_TYPE,
		payload,
	};
};

/**
 * Updates a question answers
 *
 * @param {*} question
 * @param {*} answers
 */
export const updateQuestionAnswers = ( question, answers ) => {
	return {
		type: UPDATE_QUESTION_ANSWERS,
		question,
		answers,
	};
};
